import React, { useEffect, useState, useRef } from 'react';
import ApiRequester from "../ApiRequester.jsx";
import {toast, ToastContainer} from "react-toastify";
import CampusDropDown from "../component-assets/CampusDropDown.jsx";
import {iAmHigherAuthority} from "../../libs.jsx";
import { getSession } from "../../services/session";

const LocationList = ({onLocationSelect, onLocationsUpdate, onAlertedDevicesUpdate, locations,
                          alertedDevices, mapRef, campusId, setCampusId, setCount}) => {
    let dData = getSession();

    const [searchTerm, setSearchTerm] = useState('');
    const [trackingMode, setTrackingMode] = useState(false);
    const [trackedLocations, setTrackedLocations] = useState(new Set());
    const [longPressTimer, setLongPressTimer] = useState(null);
    const [pressedButton, setPressedButton] = useState(null);
    const [trackedLocationsCoords, setTrackedLocationsCoords] = useState(new Map());

    const listContainerStyle = {
        padding: '15px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
    };

    const refreshButtonStyle = {
        position: 'absolute',
        top: '20px',
        right: '20px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        border: 'none',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: 'white',
        transition: 'background-color 0.2s',
        padding: '0',
    };

    const trackingCounterStyle = {
        textAlign: 'center',
        color: 'white',
        padding: '8px 0',
        fontSize: '14px',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        marginTop: '5px',
    };

    const scrollableListStyle = {
        height: 'auto',
        overflowY: 'auto',
        margin: '15px 0',
        paddingRight: '5px',
    };

    const titleStyle = {
        margin: '0',
        color: 'white',
        textAlign: 'center',
    };

    const searchInputStyle = {
        width: '90%',
        padding: '8px',
        margin: '15px auto 0 auto',
        display: 'block',
        border: 'none',
        borderRadius: '4px',
        background: 'rgba(255, 255, 255, 0.9)',
        color: '#333',
    };

    const getLocationItemStyle = (isTracked) => ({
        padding: '10px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
        cursor: 'pointer',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: isTracked ? 'rgba(76, 175, 80, 0.5)' : 'transparent',
    });

    const pingButtonStyle = (isPressed) => ({
        backgroundColor: isPressed ? '#388E3C' : '#4CAF50',
        color: 'white',
        border: 'none',
        padding: '5px 10px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px',
        marginLeft: '10px',
        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
        transition: 'all 0.1s ease',
        boxShadow: isPressed ? 'none' : '0 2px 4px rgba(0,0,0,0.2)',
    });

    const switchContainerStyle = {
        padding: '20px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        borderTop: '1px solid rgba(255, 255, 255, 0.2)',
        marginTop: '5px',
    };

    const switchLabelStyle = {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
    };

    const switchInputStyle = {
        display: 'none'
    };

    const switchSliderStyle = {
        position: 'relative',
        display: 'inline-block',
        width: '40px',
        height: '20px',
        backgroundColor: '#ccc',
        borderRadius: '20px',
        marginRight: '10px',
        transition: '.4s',
        '&:before': {
            position: 'absolute',
            content: '""',
            height: '16px',
            width: '16px',
            left: '2px',
            bottom: '2px',
            backgroundColor: 'white',
            borderRadius: '50%',
            transition: '.4s',
        }
    };

    const handleLocationClick = (location) => {
        onLocationSelect(location);
        if (mapRef.current) {
            mapRef.current.selectMarker(location.manufacture_uuid);
        }
    };

    const handleLocationPressStart = (location) => {
        if (trackingMode) {
        const timer = setTimeout(() => {
            toggleTracking(location.manufacture_uuid);
        }, 1000); // 1 second long press
            setLongPressTimer(timer);
        }
    };

    const handleLocationPressEnd = () => {
        if (longPressTimer) {
            clearTimeout(longPressTimer);
            setLongPressTimer(null);
        }
    };

    const toggleTracking = (manufacture_uuid) => {
        setTrackedLocations(prev => {
            const newSet = new Set(prev);
            if (newSet.has(manufacture_uuid)) {
                newSet.delete(manufacture_uuid);
                // Remove from tracked coordinates when untracking
                setTrackedLocationsCoords(prev => {
                    const newMap = new Map(prev);
                    newMap.delete(manufacture_uuid);
                    return newMap;
                });
            } else {
                newSet.add(manufacture_uuid);
                // Add initial coordinates when tracking
                const location = locations.find(loc => loc.manufacture_uuid === manufacture_uuid);
                if (location) {
                    setTrackedLocationsCoords(prev => {
                        const newMap = new Map(prev);
                        newMap.set(manufacture_uuid, {
                            lat: location.lat,
                            lng: location.lng
                        });
                        return newMap;
                    });
                }
            }
            return newSet;
        });
    };

    const handlePingClick = async (e, location) => {
        e.stopPropagation();
        setPressedButton(location.manufacture_uuid);
        try {
            ApiRequester({reqEndpoint: "remotecommand", payload: {devid: location.manufacture_uuid, command: "location"},
                            source: "portal", User: dData.user, CampusId: dData.acnt, ClientId: dData.sessionId}).then(data => {
                if (data === true){
                    toast.success("Device pinged successfully")
                }
                else{
                    toast.error("Failed to ping device");
                }
                setPressedButton(null);
            });
        } catch (error) {
            console.error('Error pinging device:', error);
            setPressedButton(null);
        }
    };

    const filteredLocations = locations.filter(location =>
        location.resident_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        location.manufacture_uuid.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        if (trackingMode){
            toast.info("Tracking enabled, press and hold residents in list until highlighted green to track.")
        }else{
            setTrackedLocations(() => new Set())
        }
    }, [trackingMode])

    useEffect(() => {
        // Update tracked locations coordinates and check for changes
        const newCoords = new Map();
        let hasChanges = false;
        let changedLocation = null;

        locations.forEach(location => {
            if (trackedLocations.has(location.manufacture_uuid)) {
                const oldCoords = trackedLocationsCoords.get(location.manufacture_uuid);
                newCoords.set(location.manufacture_uuid, {
                    lat: location.latitude,
                    lng: location.longitude
                });

                // Check if coordinates have changed
                if (oldCoords && (oldCoords.lat !== location.latitude || oldCoords.lng !== location.longitude)) {
                    hasChanges = true;
                    changedLocation = location;
                }
            }
        });

        setTrackedLocationsCoords(newCoords);

        // If coordinates changed, trigger onLocationSelect
        if (hasChanges && changedLocation) {
            handleLocationClick(changedLocation);
        }
    }, [locations, trackedLocations]);

    return (
        <div style={listContainerStyle}>
            {iAmHigherAuthority(30, dData.role_weight)
                ?   <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)} pageAction={() => {}}/>
                :   <h2 style={titleStyle}>{dData.campusData[dData.acnt.toString()]?.name}</h2>
            }
            <input type="text" placeholder="Search by name or pendant #..." value={searchTerm}
                   onChange={(e) => setSearchTerm(e.target.value)} style={searchInputStyle}/>
            <div style={scrollableListStyle}>
                {filteredLocations.map(location => {
                    let isAlert = alertedDevices.some(device => device.manufacture_uuid === location.manufacture_uuid)
                    return (<div className={trackedLocations.has(location.manufacture_uuid) ? "" : "trans-hover"} key={location.manufacture_uuid}
                         style={getLocationItemStyle(trackedLocations.has(location.manufacture_uuid))}
                         onTouchStart={() => handleLocationPressStart(location)}
                         onTouchEnd={handleLocationPressEnd}
                         onMouseDown={() => handleLocationPressStart(location)}
                         onMouseUp={handleLocationPressEnd}
                         onMouseLeave={handleLocationPressEnd}
                         onClick={() => handleLocationClick(location)}>
                        <div>
                            <div className={isAlert ? "text-danger" : ""}>
                                {location.resident_name}{isAlert ? <span className={"text-danger ms-2 fw-bold fs-2"}>!</span> : <></>}
                            </div>
                            <div style={{fontSize: '12px', opacity: 0.8}}>
                                {location.manufacture_uuid}
                            </div>
                        </div>
                        <button className={"hover-success"}
                            style={pingButtonStyle(pressedButton === location.manufacture_uuid)}
                            onClick={(e) => handlePingClick(e, location)}
                            onMouseDown={() => setPressedButton(location.manufacture_uuid)}
                            onMouseUp={() => setPressedButton(null)}
                            onMouseLeave={() => setPressedButton(null)}
                            onTouchStart={() => setPressedButton(location.manufacture_uuid)}
                            onTouchEnd={() => setPressedButton(null)}>
                            Ping
                        </button>
                    </div>)
                })}
            </div>
            <div style={trackingCounterStyle}>
                Tracking: {trackedLocations.size} devices
            </div>
            <div style={switchContainerStyle}>
                <div className={"form-check form-switch d-inline-block"}>
                    <input className={`form-check-input ${trackingMode && "bg-success"}`} id={"tracking-switch"} type={"checkbox"}
                           checked={trackingMode}
                           onChange={(e) => setTrackingMode(e.target.checked)}/>
                    <label className={"form-check-label text-light"} htmlFor={"tracking-switch"}>Tracking Mode</label>
                </div>
            </div>
        </div>
    )
};

export default LocationList;